import React from 'react';

const TableContext = React.createContext({
  attrs: {},
  dispatch: () => {},
});

export default TableContext;
